import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl, offerAnchor } from '../data/content';
import { trackInitiateCheckout, trackInitiateCheckoutOnly } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  /** offer: scrolls to the offer · checkout: opens checkout · volumes: scrolls to the volumes */
  to?: 'offer' | 'checkout' | 'volumes';
  size?: 'md' | 'lg';
  block?: boolean;
  tone?: 'terra' | 'gold';
  className?: string;
};
const hrefs = {
  offer: offerAnchor,
  checkout: checkoutUrl,
  volumes: '#volumes'
};
export function CtaButton({
  children,
  to = 'offer',
  size = 'lg',
  block = false,
  tone = 'terra',
  className = ''
}: CtaButtonProps) {
  const href = hrefs[to];
  const sizes = {
    md: 'min-h-[40px] px-4 py-2 text-[12px] tracking-[0.08em]',
    lg: 'min-h-[60px] px-8 py-4 text-[14px] tracking-[0.1em] sm:px-10 sm:text-[15px]'
  };
  const tones = {
    terra: 'bg-terra-deep text-white shadow-cta hover:bg-terra-dark focus-visible:outline-terra-deep',
    gold: 'bg-gold text-ink-deep hover:bg-[#F0D58F] focus-visible:outline-gold'
  };
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (to !== 'checkout') return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) {
      trackInitiateCheckoutOnly();
      return;
    }
    e.preventDefault();
    trackInitiateCheckout(href);
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex max-w-full items-center justify-center gap-2.5 whitespace-nowrap rounded-full font-bold uppercase transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 ${sizes[size]} ${tones[tone]} ${block ? 'w-full' : ''} ${className}`} data-id="element-28" data-mp="3owa1sck2jzov">
      {children}
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-29" data-mp="biylawtp7jby" />
    </a>;
}